var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"bg",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('flightSearch',{on:{"startLoad":function($event){_vm.loading = true},"endLoad":function($event){_vm.loading = false}}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }